module.exports = __webpack_public_path__ + "img/original.0b6c77ee.png";